const state = {
  notifications: {
    special: [
    ],
  }
}

const getters = {
  getNotificationsSpecial: (state) => state.notifications.special,
}

const actions = {
  deleteSpecialNotification: ({ commit }, { val }) => {
    /**
     * Удаляет специальное уведомление
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры действия
     * @param {Object} params.val - объект уведомления для удаления
     */
    const filteredNotification = state.notifications.special.filter((item) => item.id !== val.id)
    commit('SET_NOTIFICATIONS_SPECIAL', filteredNotification)
  },
  addSpecialNotification: ({ commit }, { val }) => {
    /**
     * Добавляет специальное уведомление (если его еще нет)
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры действия
     * @param {Object} params.val - объект уведомления для добавления
     */
    const searchNotification = state.notifications.special.find((item) => item.id === val.id)
    if (!searchNotification) { commit('ADD_NOTIFICATIONS_SPECIAL', val) }
  },
}

const mutations = {
  SET_NOTIFICATIONS_SPECIAL: (state, list) => {
    /**
     * Устанавливает список специальных уведомлений
     * @param {Object} state - состояние хранилища
     * @param {Array} list - массив специальных уведомлений
     */
    state.notifications.special = list
  },
  ADD_NOTIFICATIONS_SPECIAL: (state, val) => {
    /**
     * Добавляет специальное уведомление в список
     * @param {Object} state - состояние хранилища
     * @param {Object} val - объект специального уведомления
     */
    state.notifications.special.push(val)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
